import { graphql } from "react-relay";
import { AvatarPerson } from "@components/avatar";

export const suggestionBodyLowFocusTimeFragments = {
  org: graphql`
    fragment SuggestionBodyLowFocusTime_org on Org
    @argumentDefinitions(calendarIds: { type: "[String]!", defaultValue: [] }) {
      ...AvatarPerson_org
      id
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            ...AvatarPerson_person
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
  suggestionPayload: graphql`
    fragment SuggestionBodyLowFocusTime_suggestionPayload on SuggestionResultLowFocusTimePayload {
      calendarId
      totalFocusTimeMinutes
      totalMinutes
      week
    }
  `,
};

export const refetchQuery = graphql`
  query SuggestionBodyLowFocusTimeQuery($orgRelayId: ID!, $calendarIds: [String]!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...SuggestionBodyLowFocusTime_org @arguments(calendarIds: $calendarIds)
      }
    }
  }
`;
